import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _26d356a8 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _53764920 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _7a31b343 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _0cf5227b = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _2c525f1b = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _23a9060a = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _201ccf0e = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _079d51d8 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _74cbc79d = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _794d6284 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _20b215dc = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _097013be = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _50d41144 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _3dc1b69b = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _7d147e5a = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _1909ecfe = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _5531ec65 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _088b975b = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _116191a0 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _12a4e100 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _0ac0b305 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _bcf57192 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _2a6502ab = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _6c892ce2 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _b26175b0 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _22d43efd = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _53d84f7f = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _0f25d4e3 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _45406281 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _7822c087 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _113bb6be = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _1de974e2 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _95cf884c = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _73bdcb92 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _2b3d03d4 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _2c2190e0 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _26caa7aa = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _14cb2a73 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _4fd3522a = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _620459a5 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _774db825 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _00aec61e = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _fddb8ca4 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _2808dd3f = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _4f873a82 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _7629128e = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _04424b90 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _71f0d952 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _8d95424c = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _1c8dbd5a = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _15cfff61 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _15185eae = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _d4c6e4d4 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _2dae2e88 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _501d65bb = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _73ebd220 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _34d2b183 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _95e91c08 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _0b5840e9 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _f040ef58 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _e969af90 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _2ed9b40b = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _7d576cc2 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _510d8a7a = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _38abbd53 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _3dd239e0 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _b3ecab2a = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _cae7d112 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _d8d9277a = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _861de576 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _003313fa = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _b774b498 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _5b4b3908 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _8e6dbf14 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _257f1bc2 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _466824b4 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _26d356a8,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _53764920,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _7a31b343,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _0cf5227b,
    name: "calendar"
  }, {
    path: "/customer",
    component: _2c525f1b,
    name: "customer"
  }, {
    path: "/details",
    component: _23a9060a,
    name: "details"
  }, {
    path: "/goals",
    component: _201ccf0e,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _079d51d8,
    name: "maisoku"
  }, {
    path: "/media",
    component: _74cbc79d,
    name: "media"
  }, {
    path: "/privacy",
    component: _794d6284,
    name: "privacy"
  }, {
    path: "/project",
    component: _20b215dc,
    name: "project"
  }, {
    path: "/response",
    component: _097013be,
    name: "response"
  }, {
    path: "/sale",
    component: _50d41144,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _3dc1b69b,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _7d147e5a,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _1909ecfe,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _5531ec65,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _088b975b,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _116191a0,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _12a4e100,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _0ac0b305,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _bcf57192,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _2a6502ab,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _6c892ce2,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _b26175b0,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _22d43efd,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _53d84f7f,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _0f25d4e3,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _45406281,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _7822c087,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _113bb6be,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _1de974e2,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _95cf884c,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _73bdcb92,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _2b3d03d4,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _2c2190e0,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _26caa7aa,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _14cb2a73,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _4fd3522a,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _620459a5,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _774db825,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _00aec61e,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _fddb8ca4,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _2808dd3f,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _4f873a82,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _7629128e,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _04424b90,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _71f0d952,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _8d95424c,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _1c8dbd5a,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _15cfff61,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _15185eae,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _d4c6e4d4,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _2dae2e88,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _501d65bb,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _73ebd220,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _34d2b183,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _95e91c08,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _0b5840e9,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _f040ef58,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _e969af90,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _2ed9b40b,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _7d576cc2,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _510d8a7a,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _38abbd53,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _3dd239e0,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _b3ecab2a,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _cae7d112,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _d8d9277a,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _861de576,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _003313fa,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _b774b498,
    name: "property-property",
    children: [{
      path: "contact",
      component: _5b4b3908,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _8e6dbf14,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _257f1bc2,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _466824b4,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
